<script lang="ts">
    import { fade } from 'svelte/transition';
    import WinAnimation from '../animations/win-animation.svelte';
    import WinAmount from './win-amount.svelte';
    import { ANIMATION_ORDER } from '../../../utils/animations';
    import { GameResult } from '@root/src/types';

    export let gameResult: GameResult = null;
    export let currency: string;

    const animationTypeOrderIndex = ANIMATION_ORDER.indexOf(gameResult?.type) || 0;
    // duration of show and then hide any type of animation artBoard
    const WIN_ANIMATION_SHOW_HIDE_DURATION = 1.25; //s
    const duration = (animationTypeOrderIndex + 1) * WIN_ANIMATION_SHOW_HIDE_DURATION;
</script>

<div class="absolute inset-0 -top-[var(--ui-screen-top)] z-[9001] h-full w-full -translate-y-8">
    <div
        class=" relative z-[9001] flex h-full w-full flex-col items-center justify-center desktop:-translate-y-12"
        out:fade|global
    >
        <WinAnimation {animationTypeOrderIndex} {duration}>
            <WinAmount amount={gameResult.winAmount} {duration} {currency} />
        </WinAnimation>
    </div>
</div>
